import { baseApi } from "../../services/rtkApi/baseApi";

// Admin side of the home banner. The home page itself does not use these: it reads through
// useHomeBanner (plain fetch, no auth header, remembered in localStorage).

export interface HomeBanner {
  text1: string;
  text2: string;
  updatedAt: string | null;
}

export const HOME_BANNER_MAX_LENGTH = 500;

const homeBannerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHomeBanner: builder.query<HomeBanner, void>({
      query: () => "/home-banner",
      providesTags: ["HomeBanner"],
    }),
    setHomeBanner: builder.mutation<HomeBanner, Partial<Pick<HomeBanner, "text1" | "text2">>>({
      query: (body) => ({ url: "/home-banner", method: "PUT", body }),
      invalidatesTags: ["HomeBanner"],
    }),
  }),
});

export const { useGetHomeBannerQuery, useSetHomeBannerMutation } = homeBannerApi;
